import React from "react";
import { Box, Container, ThemeProvider, Typography } from "@mui/material";
import theme from "../../theme";
import UserNavbarComponent from "../../components/Navbar/UserNavbarComponent";

export default function PrivacyPolicyPage({ history }) {
  return (
    <ThemeProvider theme={theme}>
      <UserNavbarComponent history={history} />
      <Container
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Box
          sx={{
            width: "95%",
            maxWidth: "900px",
            display: "flex",
            flexDirection: "column",
            gap: "14px",
            paddingY: "24px",
          }}
        >
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            Privacy Policy
          </Typography>
          <Typography sx={{ lineHeight: 1.9 }}>
            We respect your privacy and are committed to protecting your
            personal information. This page explains what data we collect,
            how we use it, and how we keep it secure. If you have any
            questions, please contact us.
          </Typography>
        </Box>
      </Container>
    </ThemeProvider>
  );
}
